/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-10 17:15:40
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-07 16:32:40
 * @FilePath: \baishu_react_ui\src\components\BsyUserCont\JobtitleList.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import BsyDialog from '../BsyDialog';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
const DragHandle = sortableHandle(() => <i className="icon-drag-table" onClick={e => { e.stopPropagation(); }} />);

const SortableItem = sortableElement((props) => (
    <>{props.children}</>
));

const SortableContainer = sortableContainer(({ children }) => {
    return <div className={'group-box'}>{children}</div>;
});


class JobtitleList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jobtitles: props.jobtitles,
            sortEnabled: props.sortEnabled || false,
            selectJobtitle: [],
        }
        this.batchText = React.createRef();
    }

    onSortEnd = (data, groupInfo) => {
        const { oldIndex, newIndex } = data;
        const scr = arrayMoveImmutable(groupInfo, oldIndex, newIndex);
        this.setState({
            jobtitles: scr,
        }, () => {
            this.props.onSortPost && this.props.onSortPost(scr)
        })


    };

    extractText = (inputString) => {
        const regex = /[\u4e00-\u9fa5a-zA-Z0-9]+/g;
        const matches = inputString.match(regex);

        if (matches) {
            return matches.join('');
        } else {
            return '';
        }
    }

    addJobtitle = (e) => {
        const { jobtitles } = this.state;
        let adds = [];
        let jbomap = [];
        let maxLength =[];
        for (let i = 0; i < jobtitles.length; i++) {
            jbomap.push(jobtitles[i].value)
        }
        let repeats = [];
        BsyDialog({
            title: React.language("address.book.dept.jobtitle.addnew"),
            height: 470,
            width: 450,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                setTimeout(()=>{
                    this.batchText.current && this.batchText.current.focus();
                }, 30)
                return <div className="add-jobtitle-name">
                    <div className="add-jobtitle-tip">*{React.language("address.book.dept.jobtitle.addnew.tip")}</div>
                    <textarea
                      ref={this.batchText}
                      style={{ height: 290, lineHeight: "20px", marginTop: 12 }}
                      onKeyUp={e => {
                          adds = [];
                          repeats = [];
                          maxLength =[]
                          let val = e.target.value;
                          let ds = val.split('\n');
                          for (let index = 0; index < ds.length; index++) {
                              let element = this.extractText(ds[index].trim()) + "";
                              if (element) {
                                  element += "";

                                  if (jbomap.indexOf(element) === -1) {
                                      if(element.length > 16){
                                          maxLength.push(element)
                                      }else {
                                          adds.push({
                                              value:element.trim(),
                                              exact: false
                                          })
                                      }
                                  } else {
                                      repeats.push(element)
                                  }
                              }
                          }
                      }}
                    >

                    </textarea>
                </div>
            },
            onOk: () => {
                if(maxLength.length){
                    tipAlert({
                        type: 'warning',
                        msg: React.language('position.add.tip1',{name: maxLength.join('、'), max: 16})
                    })
                    return false
                }
                if (repeats.length) {
                    tipAlert({
                        type: 'warning',
                        msg: React.language('position.add.tip2',{name: repeats.join('、')})
                    })
                    return false
                }
                this.setState({
                    jobtitles: [...jobtitles, ...adds]
                }, () => {

                    this.props.onSortPost && this.props.onSortPost(this.state.jobtitles)
                })
            }
        })
    }

    removeJobtitle = (jobtitle) => {
        const { jobtitles } = this.state;
        const scr = jobtitles.filter((data) => {
            return jobtitle.value !== data.value
        })
        this.setState({ jobtitles: scr }, () => {
            this.props.onSortPost && this.props.onSortPost(scr)
        })
    }

    render() {
        const { jobtitles, sortEnabled, selectJobtitle } = this.state;
        return (
            <>
                <div className="job-title"><span className="title"> {React.language('address.book.dept.set.title.select')} </span>

                    {
                        <span className={'sim-title'} onClick={this.addJobtitle} >{React.language('address.book.dept.jobtitle.add')}</span>
                    }
                </div>
                <ul className={'job-title-list'} >

                    <SortableContainer
                        axis={'y'}
                        distance={10}
                        useDragHandle={true}
                        onSortEnd={e => { this.onSortEnd(e, jobtitles) }}
                    >

                        {

                            jobtitles.map((data, index) => {

                                return <SortableItem key={`item-${index}`} index={index} value={data} >
                                    <li onClick={e => {

                                        var selectJobtitles = [...selectJobtitle]
                                        if(selectJobtitle.indexOf(data.value) < 0) {
                                            selectJobtitles.push(data.value)
                                        }else{
                                            selectJobtitles.splice(selectJobtitle.indexOf(data.value), 1)
                                        }

                                        this.props.onStopEdit && this.props.onStopEdit(selectJobtitles)
                                        this.setState({selectJobtitle: selectJobtitles})
                                    }}
                                        className={'job-title-list-li ' + (selectJobtitle.indexOf(data.value) > -1 ? 'select' : '')} > <i class="icon-bsy-check2"></i>{data.value}
                                        {
                                            sortEnabled ? <DragHandle /> : ''
                                        }
                                        {
                                            (!data.exist && this.selectJobtitle !== data.value) ? <i class="icon-close-large" onClick={e => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                this.removeJobtitle(data)
                                            }} > </i> : ''
                                        }
                                    </li>

                                </SortableItem>
                            })
                        }
                    </SortableContainer>
                </ul >

            </>
        )
    }


}


export default JobtitleList;